import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { NGXLogger } from "ngx-logger";
import { tap, withLatestFrom } from "rxjs/operators";
import { LocalStorageService } from "src/app/modules/local-storage/local-storage.service";
import { LoggingActions, LoggingActionTypes } from "./logging.actions";
import { loggingFeatureKey } from "./logging.reducer";

@Injectable()
export class LoggingEffects {
  setLogLevel$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoggingActionTypes.SetLogLevel),
        withLatestFrom(this.store),
        tap(([, state]) => {
          const loggingStateSnapshot = state[loggingFeatureKey];
          this.logger.debug(
            `SIDE EFFECT: persist ${loggingFeatureKey}`,
            loggingStateSnapshot,
          );
          this.service.persist(loggingFeatureKey, loggingStateSnapshot);
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions<LoggingActions>,
    private store: Store<any>,
    private service: LocalStorageService,
    private logger: NGXLogger,
  ) {}
}
